<template>
    <div>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="已获取全部数据~"
                @load="onLoad"
        >
            <div v-if="list && list.length > 0">
                <div
                    v-for="(item, index) in list"
                    v-bind:key="index"
                >
                    <van-cell>
                        <van-image style="width: 40px" slot="icon" :src="item.user_icon" round />
                        <div slot="title" style="margin-left: 15px;  height: 30px; line-height: 20px">
                            <div style="font-size: 17px; font-weight: bold;">
                                {{item.user_name}}
                                <span v-if="memberType === '0' && item.channel_name" style="font-size: 14px; font-weight: normal">
                                    ({{item.channel_name}})
                                </span>
                            </div>
                            <div style="font-size: 12px; color: #888888;">
                                {{formatPhoneNumber(item.phone)}}
                            </div>
                        </div>
                    </van-cell>
                </div>
            </div>
        </van-list>

    </div>
</template>

<script>
    export default {
        name: "Wp_mini_member_fans_model",

        props:{
            memberType:{type: String, default: ""}//默认空表示全部；-1，超级；10，注册
        },

        data(){
            return{
                //上拉加载的临时list
                list: [],
                //上拉加载状态结束
                loading: false,
                //数据全部加载完成的状态
                finished: false,

                //请求数据页码
                page_index: 1,
                //一次页面请求多少数据
                page_size: 20,

            }
        },

        created(){
            // this.getFansList();
            // this.onLoad();
        },


        methods:{

            formatPhoneNumber(phone) {
                if (phone && phone !== "0") {
                    let start = phone.substring(0, 3);
                    let end = phone.substring(7, 11);
                    // this.$log("start = " + start)
                    // this.$log("end = " + end)

                    return start + "****" + end;
                }
                return ""
            },

            // testData(){
            //     let arr = [];
            //     let list = [{
            //         city: "Fengtai",
            //         country: "China",
            //         createtime: "2019-12-01 19:34:04",
            //         f_code: "35392a",
            //         f_id: "1825357253",
            //         f_name: "a118",
            //         f_user_id: "E80746F17F3393155B9F24546935392A",
            //         from_type: "app",
            //         id: "7BC6DBC7CD7CDCDAA1F22822CE1FCE39",
            //         modifytime: "2019-12-01 19:34:08",
            //         open_id: "okwvd4iegONDMpoRY0UVw5OrsoSs",
            //         phone: "13810889527",
            //         province: "Beijing",
            //         role_id: "0",
            //         u_code: "1fce39",
            //         user_icon: "https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKVztic66aV5IQAG7lQ2UO1JKSgINqfIyu1iaBJ1cickicxK1bSyFlLLaFxhYX2vgNmtg4DTibSCXKAAiaQ/132",
            //         user_name: "凤梨罐头",
            //         user_sex: "1",
            //         user_type: "app",
            //     }];
            //
            //     for(let i = 0; i < 20; i ++){
            //         arr.push(list[0]);
            //     }
            //     this.$log(arr)
            //     return arr;
            // },

            /**
             * 上拉加载
             */
            onLoad() {
                //选品清单重置
                // this.$refs.jdSelectListSheet.releaseSelectData();

                this.loading = true;
                // 更新数据
                this.getFansList(datas=>{
                    this.loadDatas(datas);
                })
            },

            loadDatas(datas) {
                if (datas && datas.length > 0) {
                    //list一次加载的数据
                    // let data_size = this.page_size;
                    // //如果总数据数组的length小于没次加载的限制值，则直接使用数组length
                    // if (data_size === 0) {
                    //     data_size = datas.length;
                    //     //如果一次获取到的数据，小于限制的数值，则表示数据已全部获取完成
                    //     this.finished = true;
                    // } else {
                    //     this.finished = false;
                    // }

                    // this.list = datas;

                    for(let i = 0; i< this.page_size; i++){
                        if(datas[i]){
                            this.list.push(datas[i])
                        }
                    }

                    // 加载状态结束。
                    this.loading = false;

                    this.page_index += 1;
                } else {
                    this.$log("222")
                    // 加载状态结束
                    this.loading = false;
                    // 获取数据结束
                    this.finished = true;
                }
            },

            /**
             * 获取粉丝数据
             */
            getFansList(fn){
                this.$log("this.memberType = " + this.memberType)
                let role = this.memberType;

                let params = {
                    id: this.$common.gloabl_wx_mini_user_info.id,
                    page: this.page_index,
                    size: this.page_size,
                };
                if(role){
                    params.role = role;
                }


                this.$getFansList(params, respones=>{
                    this.$log(respones)
                    if(respones && respones.code === 200 && respones.list){
                        if(fn){
                            fn(respones.list)
                        }
                    }
                })
            },

            /**
             * 导航返回键
             */
            onClickBack(){
                this.$router.back();
            },

        }
    }
</script>

<style scoped>

</style>